<template>
  <div
    class="expandable-item relative"
    :class="{'active': isActive}"
  >
    <button
      aria-haspopup="true"
      :aria-expanded="isActive"
      :aria-controls="contentId"
      :title="toggleTitle"
      class="expandable-item__header hover--pointer"
      @click="toggle"
    >
      <slot name="header" />
      <span 
        v-if="showArrow"
        class="drop-arrow drop-arrow--end"
        :class="arrowClass"
        :style="arrowTransformStyle"
      />
    </button>
    <div
      v-show="isActive"
      :id="contentId"
      class="expandable-item__container"
    >
      <slot name="content" />
    </div>
  </div>
</template>


<script>
import mixinPopupCloseListeners from '../../mixins/mixin-popup-close-listeners'

export default {
  mixins: [mixinPopupCloseListeners({closeCallback: 'close'})],
  props: {
    showArrow: {
      type: Boolean,
      default: false
    },
    toggleTitle: {
      type: String,
      default: 'Expand content'
    },
    isArrowWhite: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isActive: false,
      contentId: `expandable-item-content-${this._uid}`
    }
  },

  computed: {
    arrowTransformStyle () {
      return {
        transform: this.isActive ? 'rotate(180deg)' : 'rotate(0deg)'
      }
    },

    arrowClass () {
      return this.isArrowWhite ?
        'arrow-svg--white' : 'arrow-svg'
    }
  },
  
  methods: {
    toggle () {
      this.isActive ? this.close() : this.open()
    },
    close () {
      this.isActive = false
    },
    open () {
      this.isActive = true
    }
  }
}
</script>
